import React, { useEffect, useState } from "react";
import Header from "../master/SideBar";
import Nav from "../master/NavBar";
import { LoadingDiv, SweetAlertShow } from "../master/Master";

import { courseList } from "../../api/Courses";
import { batchList } from "../../api/Batch";
import { StaffList } from "../../api/Staff";

import Master from "./Master";
import StudentAttendanceMesstable from "./components/StudentAttendanceMesstable";

export default function StudentAttendanceAndMessages() {

    const [loading, setLoading] = useState(false);

    const [courses, setCourses] = useState([]);
    const [batches, setBatches] = useState([]);
    const [staffs, setStaffs] = useState([]);
    const [sessions, setSessions] = useState([]);

    const [filters, setFilters] = useState({
    session_id: "",
    course_id: "",
    batch_id: "",
    staff_id: "",
    attendance: "",
    message_filter: "",
    date: new Date().toISOString().split("T")[0],
});

    /*
    |--------------------------------------------------------------------------
    | SESSIONS
    |--------------------------------------------------------------------------
    */

    useEffect(() => {

        const parseSessions = JSON.parse(
            localStorage.getItem("sessions") ?? "[]"
        );

        setSessions(parseSessions);

    }, []);

    /*
    |--------------------------------------------------------------------------
    | ACTIVE SESSION
    |--------------------------------------------------------------------------
    */

    useEffect(() => {

        const activeSession = sessions?.find(
            (session) => Number(session?.status) === 1
        )?.id;

        if (!activeSession) {
            return;
        }

        setFilters((prev) => {

            if (prev.session_id) {
                return prev;
            }

            return {
                ...prev,
                session_id: activeSession,
            };
        });

    }, [sessions]);

    /*
    |--------------------------------------------------------------------------
    | COURSE
    |--------------------------------------------------------------------------
    */

    const getCourse = async () => {

        setLoading(true);

        try {

            const response = await courseList();

            if (response?.data?.status) {

                setCourses(response?.data?.data ?? []);

            } else {

                SweetAlertShow(
                    "info",
                    "Warning",
                    response?.data?.message
                );
            }

        } catch (error) {

            SweetAlertShow(
                "error",
                "Error",
                error?.response?.data?.message ?? error?.message
            );

        } finally {

            setLoading(false);
        }
    };

    /*
    |--------------------------------------------------------------------------
    | STAFF
    |--------------------------------------------------------------------------
    */

    const getStaffs = async () => {

        setLoading(true);

        try {

            const response = await StaffList("status=1");

            if (response?.data?.status) {

                setStaffs(response?.data?.data ?? []);

            } else {

                SweetAlertShow(
                    "info",
                    "Warning",
                    response?.data?.message
                );
            }

        } catch (error) {

            SweetAlertShow(
                "error",
                "Error",
                error?.response?.data?.message ?? error?.message
            );

        } finally {

            setLoading(false);
        }
    };

    /*
    |--------------------------------------------------------------------------
    | BATCHES
    |--------------------------------------------------------------------------
    */

    const getBatches = async () => {

        setLoading(true);

        try {

            let addUrl = "&status=1";

            if (filters?.course_id) {
                addUrl += `&course_id=${filters.course_id}`;
            }

            if (filters?.session_id) {
                addUrl += `&session_id=${filters.session_id}`;
            }

            const response = await batchList(addUrl);

            if (response?.data?.status) {

                setBatches(response?.data?.data ?? []);

            } else {

                SweetAlertShow(
                    "info",
                    "Warning",
                    response?.data?.message
                );
            }

        } catch (error) {

            SweetAlertShow(
                "error",
                "Error",
                error?.response?.data?.message ?? error?.message
            );

        } finally {

            setLoading(false);
        }
    };

    /*
    |--------------------------------------------------------------------------
    | INITIAL API
    |--------------------------------------------------------------------------
    */

    useEffect(() => {

        getCourse();
        getStaffs();

    }, []);

    /*
    |--------------------------------------------------------------------------
    | BATCH API
    |--------------------------------------------------------------------------
    */

    useEffect(() => {

        if (filters?.session_id) {
            getBatches();
        }

    }, [
        filters?.session_id,
        filters?.course_id,
    ]);

    /*
    |--------------------------------------------------------------------------
    | FILTER
    |--------------------------------------------------------------------------
    */

    const updateFilter = (key, value) => {

        setFilters((prev) => ({
            ...prev,
            [key]: value,
        }));

    };

    /*
    |--------------------------------------------------------------------------
    | UI
    |--------------------------------------------------------------------------
    */

    return (
        <>
            {loading && <LoadingDiv />}

            <div className="layout-wrapper layout-content-navbar">

                <div className="layout-container">

                    <Header />

                    <div className="layout-page">

                        <Nav />

                        <div className="content-wrapper">

                            <div className="container-fluid flex-grow-1 container-p-y">

                                <div className="row">

                                    <Master />

                                    <div className="col-12">

                                        {/* =====================================================
                                            FILTER CARD
                                        ====================================================== */}

                                        <div className="card">

                                            <div className="card-body py-3">

                                                <div className="row g-2">

                                                    {/* TITLE */}

                                                    <div className="col-12 mb-1">

                                                        <h4 className="text-primary mb-0">
                                                            Student Attendance & Messages
                                                        </h4>

                                                        <small className="text-muted">
                                                            Attendance, Push Notification and Meta WhatsApp status
                                                        </small>

                                                    </div>

                                                    {/* SESSION */}

                                                    <div className="col-lg-2 col-md-4 col-sm-6">

                                                        <div className="form-floating form-floating-outline">

                                                            <select
                                                                className="form-select"
                                                                value={filters?.session_id ?? ""}
                                                                onChange={(e) =>
                                                                    updateFilter(
                                                                        "session_id",
                                                                        e.target.value
                                                                    )
                                                                }
                                                            >

                                                                <option value="">
                                                                    Select Session
                                                                </option>

                                                                {sessions?.map((session) => (

                                                                    <option
                                                                        key={session?.id}
                                                                        value={session?.id}
                                                                    >
                                                                        {session?.session}
                                                                        {" : "}
                                                                        {Number(session?.status) === 1
                                                                            ? "Active"
                                                                            : "Inactive"}
                                                                    </option>

                                                                ))}

                                                            </select>

                                                            <label>Session</label>

                                                        </div>

                                                    </div>

                                                    {/* COURSE */}

                                                    <div className="col-lg-2 col-md-4 col-sm-6">

                                                        <div className="form-floating form-floating-outline">

                                                            <select
                                                                className="form-select"
                                                                value={filters?.course_id ?? ""}
                                                                onChange={(e) =>
                                                                    updateFilter(
                                                                        "course_id",
                                                                        e.target.value
                                                                    )
                                                                }
                                                            >

                                                                <option value="">
                                                                    Select Courses
                                                                </option>

                                                                {courses?.map((course) => (

                                                                    <option
                                                                        key={course?.id}
                                                                        value={course?.id}
                                                                    >
                                                                        {course?.title}
                                                                    </option>

                                                                ))}

                                                            </select>

                                                            <label>Course</label>

                                                        </div>

                                                    </div>

                                                    {/* BATCH */}

                                                    <div className="col-lg-2 col-md-4 col-sm-6">

                                                        <div className="form-floating form-floating-outline">

                                                            <select
                                                                className="form-select"
                                                                value={filters?.batch_id ?? ""}
                                                                onChange={(e) =>
                                                                    updateFilter(
                                                                        "batch_id",
                                                                        e.target.value
                                                                    )
                                                                }
                                                            >

                                                                <option value="">
                                                                    Select Batches
                                                                </option>

                                                                {batches?.map((batch) => (

                                                                    <option
                                                                        key={batch?.id}
                                                                        value={batch?.id}
                                                                    >
                                                                        {batch?.title}
                                                                    </option>

                                                                ))}

                                                            </select>

                                                            <label>Batch</label>

                                                        </div>

                                                    </div>

                                                    {/* STAFF */}

                                                    <div className="col-lg-2 col-md-4 col-sm-6">

                                                        <div className="form-floating form-floating-outline">

                                                            <select
                                                                className="form-select"
                                                                value={filters?.staff_id ?? ""}
                                                                onChange={(e) =>
                                                                    updateFilter(
                                                                        "staff_id",
                                                                        e.target.value
                                                                    )
                                                                }
                                                            >

                                                                <option value="">
                                                                    All Teachers
                                                                </option>

                                                                {staffs?.map((staff) => (

                                                                    <option
                                                                        key={staff?.id}
                                                                        value={staff?.id}
                                                                    >
                                                                        {staff?.name}
                                                                        {" ("}
                                                                        {staff?.registration_no}
                                                                        {")"}
                                                                    </option>

                                                                ))}

                                                            </select>

                                                            <label>Class Teacher</label>

                                                        </div>

                                                    </div>

                                                    {/* DATE */}

                                                    <div className="col-lg-2 col-md-4 col-sm-6">

                                                        <div className="form-floating form-floating-outline">

                                                            <input
                                                                type="date"
                                                                className="form-control"
                                                                value={filters?.date ?? ""}
                                                                onChange={(e) =>
                                                                    updateFilter(
                                                                        "date",
                                                                        e.target.value
                                                                    )
                                                                }
                                                            />

                                                            <label>Date</label>

                                                        </div>

                                                    </div>

                                                </div>

                                            </div>

                                        </div>

                                        {/* =====================================================
                                            DASHBOARD
                                        ====================================================== */}

                                        <div className="card mt-3">

                                            <div className="card-body py-3">

                                                <StudentAttendanceMesstable
                                                    filters={filters}
                                                    setFilters={setFilters}
                                                />

                                            </div>

                                        </div>

                                    </div>

                                </div>

                            </div>

                        </div>

                    </div>

                </div>

            </div>
        </>
    );
}